/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  unreadCount: 0,
  loading: false,
  error: null,
};

const catchupSlice = createSlice({
  name: 'catchup',
  initialState,
  reducers: {
    setUnreadCatchupCount: (state, { payload }) => {
      state.unreadCount = payload;
    },
    getUnreadCatchupCount: (state) => state.unreadCount,
  },
});

export const {
  setUnreadCatchupCount,
  getUnreadCatchupCount,
} = catchupSlice.actions;

export const catchupSelector = (state) => state.catchup;

export default catchupSlice.reducer;
